import { Pipe, PipeTransform } from '@angular/core';
import { CRA } from '../models/cra/cra';

@Pipe({ name: 'filterCRAsByStatus' })
export class FilterCRAsByStatusPipe implements PipeTransform {
  transform(craList: CRA[], status: string): CRA[] {
    return (craList || []).filter((cra) => status.includes(cra.status));
  }
}
